module.exports = __webpack_public_path__ + "media/images/peb/8mm/peb_c-3676c3b284ebfc0e321976222a84d586.png";